import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=22a3e128&scoped=true"
import script from "./rights.vue?vue&type=script&lang=js"
export * from "./rights.vue?vue&type=script&lang=js"
import style0 from "./rights.vue?vue&type=style&index=0&id=22a3e128&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3e128",
  null
  
)

export default component.exports